



























import Vue from 'vue'
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import {Getter, State} from 'vuex-class';
import UserGroup from '@/modules/user/model/UserGroup';
import {notify} from '@/modules/core/notification';

/**
 * Pantalla que pide al usuario confirmación para el grupo de usuario actualmente
 * seleccionado
 */
@Component
export default class ConfirmDeleteUserGroup extends Vue {
    
    @State(state => state.user.checkingiDeleteFromBBDDUnigest)
    public checkingiDeleteFromBBDDUnigest: boolean

    /**
    * Comprueba si el módulo argumentado se encuentra activo en la aplicación
    */
    @Getter('moduleIsEnabled')
    public moduleIsEnabled: (module: string) => boolean

    /**
     * Grupo de usuarios actualmente seleccionado
     *
     * @var { UserGroup }
     */
    @State(state => state.user.userGroup)
    public group: UserGroup

    /**
     * Controla la visibilidad del dialogo
     */
    @Prop({type: Boolean, default: false})
    public value: boolean

    public deleting = false

    public created() {
        this.$store.commit('user/TOGGLE_USER_GROUP_DELETE_PLAFORM_UNIGEST', false)
    }
    /**
     * Solicita a la aplicación la eliminación del grupo de usuarios actualmente
     * seleccionado
     */
    public async deleteUserGroup () {
        this.deleting = true
        await this.$store.dispatch('user/beforeDeleteUserGroup',{delay:100})
        await this.$store.dispatch('user/deleteUserGroup')

        this.deleting = false
        this.$emit('input', false)

        notify('El grupo de usuarios se ha eliminado correctamente')

        // Si el dialogo ha sido cargada desde la pantalla de edición del grupo se redirecciona
        // a la pantalla con la lista
        if (this.$route.name === 'user-group') {
            await this.$router.push({name: 'user-groups'})
        }
    }

    public errorCaptured () {
        this.deleting = false
    }

    public oncheckingiDeleteFromBBDDUnigest(event: boolean) {
        event = event || false;
        this.$store.commit('user/TOGGLE_USER_GROUP_DELETE_PLAFORM_UNIGEST', event)
    }
}
